import { Maybe } from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

interface ListItemTextStackProps {
  primaryCopy: string;
  secondaryCopy?: Maybe<string>;
  isDisabled?: Maybe<boolean>;
  isStepCompleted?: Maybe<boolean>;
}

const TaskListItemTextStack = ({
  primaryCopy,
  secondaryCopy,
  isDisabled = false,
  isStepCompleted = false,
}: ListItemTextStackProps) => {
  let primaryTextStyle = styles.textPrimary;

  if (isStepCompleted) {
    primaryTextStyle = styles.completedText;
  } else if (isDisabled) {
    primaryTextStyle = styles.disabledText;
  }

  const secondaryStyle = isDisabled
    ? styles.disabledText
    : styles.textSecondary;

  return (
    <View style={styles.container}>
      {primaryCopy ? (
        <BodyBaseText
          style={[styles.textAlignment, primaryTextStyle]}
          testID="listitem-primary-label"
          accessible
        >
          {primaryCopy}
        </BodyBaseText>
      ) : null}
      {!isStepCompleted && secondaryCopy ? (
        <BodyXSText
          style={[styles.textAlignment, secondaryStyle]}
          testID="listitem-secondary-label"
          accessible
        >
          {secondaryCopy}
        </BodyXSText>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  completedText: {
    color: theme.color.text.secondary,
    textDecorationLine: 'line-through',
  },
  container: {
    flexShrink: 1,
  },
  disabledText: {
    color: theme.color.text.muted,
  },
  textAlignment: {
    flexWrap: 'wrap',
    textAlign: 'left',
  },
  textPrimary: { color: theme.color.text.primary },
  textSecondary: {
    color: theme.color.text.secondary,
  },
});

export default TaskListItemTextStack;
